/* eslint-disable no-unused-vars */
import { Box } from "@mui/material";
import { useState } from "react";

import DynamicTable from "../../../../data/DynamicTable/dynamicTable";
import voucherHeaderForm from "./form";
import { VoucherHeaderColumns } from "../../../../data/DynamicTable/Collumns";
import { accountsmanagement } from "../../../../config";
import { allPaymentVouchers } from "../../../../data/Axios/queries";
import VoucherLineDialog from "../../Lines/voucherLineDialog";  

const base_url = accountsmanagement.uri;

function VoucherHeader() {
  

  const actions = {
    entity: "Payment Voucher",
    showStatus: true,
    edit: {
      key: "EDIT",
      button_name: "Edit",
      Show_Button: true,
      permission: "EditPermission",
    },
    add: {
      key: "ADD",
      button_name: "Add",
      Show_Button: true,
      permission: "CreatePermission",
    },
    ViewVoucherLines: {
      key: "ViewVoucherLines",
      button_name: "View Lines",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
      
    },
    PrintVoucher: { 
      key: "PRINTVOUCHER", 
      button_name: "Print", 
      Show_Button: true, 
      permission: "hasNoPermission", 
      roleGroupId: [1, 2, 3, 4], 
    },
    approvePV: {
      key: "approvePV",
      button_name: "Approve",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
    },
  };

  return (
    <Box m="10px">
      {/* Payment Voucher Table */}
      <DynamicTable
        title="Payment Vouchers"
        subtitle="View all payment voucher, create, edit and add voucher lines"
        columns={VoucherHeaderColumns}
        FormComponent={voucherHeaderForm}
        query={allPaymentVouchers}
        base_url={base_url}
        actions={actions}
        
      />
      
    </Box>
  );
}

export default VoucherHeader;
